import Skill from "@/types/Skill";
import { COLORS } from "../colors";

// Curated skills - focused on core competencies, not an exhaustive list
// Each skill group showcases 4-6 relevant technologies actually used in projects
export const SKILLS: Skill[] = [
    {
        name: "Frontend Architecture",
        slogan: 'Designing <span class="calligraphy">Pixel</span>-perfect user interfaces',
        calligraphy_colors: [COLORS.blue, COLORS.purple],
        tech_stack_ids: ["typescript", "react", "nextjs", "scss", "websocket", "i18n"],
        description:
            "I architect high-performance web applications using Next.js and React, focusing on optimized rendering pipelines, code-splitting, and SEO. By utilizing SCSS Modules and design tokens, I build modular, maintainable UI systems that prevent layout regressions in large-scale web products.",
    },
    {
        name: "Mobile Infrastructure",
        slogan: 'Native apps that <span class="calligraphy">Endure</span> challenges',
        calligraphy_colors: [COLORS.cyan, COLORS.green],
        tech_stack_ids: [
            "kotlin",
            "java",
            "jetpack-compose",
            "android-architecture",
            "coroutines-flow",
            "koin",
            "bluetooth",
        ],
        description:
            "I engineer native Android ecosystems using Kotlin and Jetpack Compose, structured around multi-module layouts and unidirectional data flows (MVI/MVVM). I utilize Kotlin Coroutines and Flows to build thread-safe, responsive applications that survive state changes and low-memory conditions.",
    },
    {
        name: "Backend Engineering",
        slogan: 'Building systems that <span class="calligraphy">Scale</span> effortlessly',
        calligraphy_colors: [COLORS.orange, COLORS.yellow],
        tech_stack_ids: ["kotlin", "spring-boot", "ktor", "nodejs", "rest-api", "websocket", "system-design"],
        description:
            "I design scalable, resilient backends with Kotlin (Spring Boot, Ktor) and Node.js. My architectures prioritize RESTful API design, database transaction integrity, role-based access control (RBAC), and lightweight concurrency protocols for low-latency operations.",
    },
    {
        name: "DevOps & Data Layer",
        slogan: 'Automated pipelines from <span class="calligraphy">Code</span> to cloud',
        calligraphy_colors: [COLORS.teal, COLORS.mint],
        tech_stack_ids: ["postgresql", "redis", "prisma", "docker", "cicd", "system-design", "mongodb"],
        description:
            "I manage structured databases and automated operations using PostgreSQL, Prisma, and Redis caching. Through containerization (Docker) and customized CI/CD pipelines, I build robust, self-healing deployment pipelines that ensure continuous integration and zero-downtime releases.",
    },
];
